export default __webpack_public_path__ + "static/media/emptyBowl.2428d9a5.png";